import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import React, { useCallback, useRef } from "react";
import { CherryHubAdminApi } from "../../api/adminApiModels";
import { useBusinessContext } from "../../context/ModelContext";
import { NewDigitalMembershipCardPassConfigForm } from "../../forms/NewDigitalMembershipCardPassConfigForm";
import { useAdminApiClient } from "../../hooks/useApiClient";
import { useToast } from "../../hooks/useToast";

interface NewDigitalMembershipCardPassConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  refresh: () => void;
}
export const NewDigitalMembershipCardPassConfigModal = ({
  isOpen,
  onClose,
  refresh,
}: NewDigitalMembershipCardPassConfigModalProps) => {
  const business = useBusinessContext();
  const apiClient = useAdminApiClient();
  const initialRef = useRef<HTMLInputElement>(null);
  const { showErrorToast, showSuccessToast } = useToast();

  const onSuccess = useCallback(() => {
    showSuccessToast("Digital Membership Card created.");
    onClose();
    refresh();
  }, [showSuccessToast, onClose]);

  const onFailure = useCallback(
    (message?: string) => {
      showErrorToast(message ?? "Digital Membership Card creation failed.");
    },
    [showErrorToast]
  );

  return (
    <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>New Digital Membership Card</ModalHeader>
        <ModalBody pb="6">
          <NewDigitalMembershipCardPassConfigForm
            apiClient={apiClient}
            business={business}
            onCancel={onClose}
            onSuccess={onSuccess}
            onFailure={onFailure}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
